const PropTypes = require("prop-types");
const Toggle = require("components/mixins/Toggle");
const assign = require("object-assign");
const {classList} = require("helpers/html");

class Expander extends Toggle {

	static get propTypes() {
		return assign(super.propTypes, {
			childrenSelector: PropTypes.string,
			minChildren: PropTypes.number
		});
	}

	static get defaultProps() {
		return assign(super.defaultProps, {
			childrenSelector: ":scope > p",
			minChildren: 2
		});
	}

	constructor(props) {
		super(props);
		this.state = {
			toggled: props.toggled
		};
	}

	shouldRender() {
		const element = this.element;
		return element && (element.querySelectorAll(this.props.childrenSelector).length >= this.props.minChildren);
	}

	render() {
		const markup = this.shouldRender() ? super.render() : null;

		return (
			<div className={classList("expander", markup == undefined ? "hidden" : null)}>{markup}</div>
		);
	}

}

module.exports = Expander;


// WEBPACK FOOTER //
// ./resources/js/components/mixins/Expander.js